import { Info } from 'lucide-react';

interface InfoTipProps {
  /** Plain-language explanation shown on hover / keyboard focus. */
  text: string;
}

/**
 * Small info affordance: an ⓘ icon that reveals a plain-language explanation on
 * hover or keyboard focus. Read-only UX aid (admin) — nothing here is exported to
 * CSV/PDF. Self-contained (no tooltip lib): CSS group hover + focus-within.
 */
export function InfoTip({ text }: InfoTipProps) {
  return (
    <span className="group relative inline-flex print:hidden">
      <button
        type="button"
        aria-label="Explain rule"
        className="rounded text-gray-300 transition-colors hover:text-gray-500 focus:text-gray-500 focus:outline-none focus-visible:ring-1 focus-visible:ring-emerald-400"
      >
        <Info className="h-3.5 w-3.5" aria-hidden />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute right-0 top-6 z-20 w-60 rounded-md bg-gray-900 px-2.5 py-1.5 text-left text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-100 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
